import { FC, HTMLAttributes } from "react";
import { useStyles } from "./Store.style";
import { useFetchVouchersBundle } from "../../hooks/resolvers/shop/useShopQuery";
import LaunchPad from "../../components/common/ServiceSelection/LaunchPad";
import { VoucherInventory } from "../../components/common/VoucherInventory/VoucherInventory";
import { Inventory } from "@onmo/graphql/graphql";

const Store: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const vouchersBundle = useFetchVouchersBundle();

  return (
    <>
      <div id="main" className={classes.store}>
        {vouchersBundle && (
          <div className={classes.grid}>
            {vouchersBundle.map((item, index) => (
              <VoucherInventory
                key={item.id + index}
                item={item}
              />
            ))}
          </div>
        )}
      </div>
      <LaunchPad />
    </>
  );
};

export default Store;